
/**
 * if status is an object with a convention of input_name: error_message like formik's error object
 * this is a convenient function get a new status object if we want to clear the status message of a particular input
 * after this is run, the caller should run setStatus(newStatus)
 * @param {object} status
 * @param {string} name
 * @returns {object} next status
 */
export function clearInputStatus(status, name) {
  // get a new status object that filters out this input's status
  const nextStatus = {};
  Object.keys(
    status,
  ).filter((inputName) => (
    inputName !== name
  )).forEach((inputName) => {
    nextStatus[inputName] = status[inputName];
  });
  return nextStatus;
}

export default clearInputStatus;
